import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-step3',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.css']
})
export class Step3Component implements OnInit {

  @Input() formParent: FormGroup;
  @Input() ubication: any;

  constructor(
    private translate: TranslateService
    ) { }

  ngOnInit(): void {
    this.getTypesExplotation();
    this.getTypesObjectives();
  }

  getTypesExplotation(){
    return this.formParent.get('exploitations').value
      .map( x => this.translate.instant(('FARM.DESITE_TO.TYPE.' + (x.type ||x)).toUpperCase()))
      .join(', ');
  }

  getTypesObjectives(){
    return this.formParent.get('objectives').value
      .map( x => this.translate.instant(('FARM.OBJECTIVES_TO.TYPE.' + (x.type || x)).toUpperCase()))
      .join(', ');
  }
}
